module.exports = __webpack_public_path__ + "static/img/ic_te.e59da3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/ic_te.png
// module id = 10Vy
// module chunks = 0